<template>
  <div class="equipmentManagement-page">
    <div class="all-content-container">
      <el-tabs :tab-position="tabPosition" style="height: 200px" v-model="activeName2">
        <el-tab-pane label="离线模板配置" name="pane1">
          <offlineModel></offlineModel>
        </el-tab-pane>
        <el-tab-pane label="分组离线配置" name="pane2">
          <offlineGroup></offlineGroup>
        </el-tab-pane>
        <el-tab-pane label="设备离线配置" name="pane3">
          <offlineDevice></offlineDevice>
        </el-tab-pane>
        <el-tab-pane label="离线记录" name="pane4">
          <offlineJl></offlineJl>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import offlineModel from '../alarmPrediction/offlineModel'
import offlineGroup from '../alarmPrediction/offlineGroup'
import offlineDevice from '../alarmPrediction/offlineDevice'
import offlineJl from '../alarmPrediction/offlineJl'

export default {
  props: {
    message: {
      type: String,
      default: 'pane1'
    }
  },
  components: {
    offlineModel,
    offlineGroup,
    offlineDevice,
    offlineJl
  },
  data() {
    return {
      tabPosition: 'left',
      activeName2: 'pane1'
    }
  },
  created() {
    this.activeName2 = this.message
    this.$forceUpdate()
  }
}
</script>
<style lang="scss">
@import '@/style/equipmentManagement.scss';
</style>